/**
 * Created by kentalito on 2015-10-13.
 */

var JobExportFormatter = {

    isFormtrappan: function(groupId){
        return groupId == 44883518;
    },
    isSkanskaAsfalt: function(groupId){
        return false;
        /*var skanskaAsfaltare = [
            68069032,   //"Skanska Asfalt -Syd 3"
            26861614,   //"labs only"
            68077360,   //"HNT"
            68077415,   //"GDL"
            85203057,   //"Skanska Asfalt - Öst 2"
            84913718,   //"Skanska Asfalt - Öst 3"
            76337488,   //"Skanska Asfalt - Norr1"
            85172656,   //"Engströms"
            84914235,   //"Närkefrakt"
            85210264,   //"Transab"
            85210252,   //"Östschakt"
            76342654    //"Örnfrakt"
        ];
        return skanskaAsfaltare.indexOf(groupId) >= 0;*/
    },
    isSkanskaSydvastSpecial: function(groupId){
        if (groupId == 57474881) return true;
        return false;
    },

    isSkanskaSpecial: function(customFields){
        return  (_(customFields).findWhere({name: "lngdm"}) || _(customFields).findWhere({name: "maxlngdm"})) &&
                _(customFields).findWhere({name: "viktkgm"}) &&
                _(customFields).findWhere({name: "totalvikt"}) &&
                _(customFields).findWhere({name: "material"}) &&
                _(customFields).findWhere({name: "kran"}) &&
                _(customFields).findWhere({name: "retur"});
    },

    addressToPostalCode: function(address){
        var addressStr = address && address.location && address.location.placeName ? address.location.placeName : '';
        var postalCode = null;
        for (var i = addressStr.length - 6 ; i > 0 ; i --){
            var part = addressStr.substr(i,6);
            console.info('part: '+part);
            var verPart  = part;
            while (verPart.indexOf(' ') > 0)
                verPart  = verPart.replace(' ','');
            console.info('verPart: '+verPart);
            if (verPart.length == 5 && !isNaN(verPart) && !postalCode){
                postalCode = this.trimSpaces(part);
                console.info(postalCode);
            }
        };
        return postalCode;
    },

    addressToStreetPart: function(address){
        var addressStr = address && address.location && address.location.placeName ? address.location.placeName : '';
        var postalCode = this.addressToPostalCode(address);
        var index = 0;
        if (postalCode)
            index = addressStr.indexOf(postalCode)
        else {
            var i = addressStr.length -1;
            while (i > 0 && index == 0){
                if (addressStr.substr(i,1) == ' ')
                    index = i;
                i --;
            }
        }
        var streetPart = addressStr.substr(0, index);
        return streetPart ? this.trimSpaces(streetPart) : '';
    },

    addressToArea: function(address){
        var addressStr = address && address.location && address.location.placeName ? address.location.placeName : '';
        var postalCode = this.addressToPostalCode(address);
        var index = 0;
        if (postalCode)
            index = addressStr.indexOf(postalCode)+postalCode.length;
        else {
            var i = addressStr.length -1;
            while (i > 0 && index == 0){
                if (addressStr.substr(i,1) == ' ')
                    index = i;
                i --;
            }
        };
        var areaPart = addressStr.substr(index, addressStr.length - index);
        return areaPart ? this.trimSpaces(areaPart) : '';

    },

    trimSpaces: function(str){
        while (str.indexOf(' ') == 0 && str.length > 1){
            str = str.substr(1,str.length);
        }
        while (str.indexOf(' ') == str.length -1 && str.length > 1){
            str = str.substr(0,str.length-1);
        }
        return str;
    },

    jobToRows: function(job, reports){
        var rows = [];
        if (this.isSkanskaSydvastSpecial(job.groupId)){
            rows = [this.createRowForSkanskaSydvastSpecial(job)];
        }
        else if (this.isSkanskaSpecial(job.customFields)){
            rows = [this.createRowForSkanskaSpecial(job)];
        }
        else if (this.isSkanskaAsfalt(job.groupId)){
            rows = [this.createRowForSkanskaAsfalt(job)];
        }
        else if (this.isFormtrappan(job.groupId)){
            rows = [this.createRowForFormtrappan(job)];
        }
        else {
            // TODO: we get an array of arrays back
            rows = this.createRowForJob(job, reports);
        }

        return rows;
    },

    generateExtraJobRow: function(job, items, labels, notes, customFields, destinations, extraRows, resources, contacts) {
        var temp = new Job();
        temp.id = job.id;
        temp.jobNo = job.jobNo;
        temp.groupPrefix = job.groupPrefix;
        if (items.length <= 0 && notes.length <= 0 && customFields.length <= 0 && destinations.length <= 0 && resources.length <= 0) {
            return extraRows;
        }

        if (items.length > 0) {
            temp.items = [];
            temp.items.push(items.pop());
        }
        if (notes && notes.length > 0) {
            temp.events = [];
            temp.events.push(notes.pop());
        }

        if (labels && labels.length > 0) {
            temp.labels = [];
            temp.labels.push(labels.pop())
        }
        if (resources && resources.length > 0) {
            if (resources[0]) {
                var tmpReport = resources[0].reports && resources[0].reports.length > 0 ? [resources[0].reports.pop()] : [];
                var tmpResourceAsset = resources[0].assets && resources[0].assets.length > 0 ? [resources[0].assets.pop()] : [];
                var tmpResource = JSON.parse(JSON.stringify(resources[0]));
                if ((!resources[0].reports || resources[0].reports.length <= 0) && (!resources[0].assets || resources[0].assets.length <= 0)) resources.shift();
            }
            tmpResource.reports = tmpReport;
            tmpResource.assets = tmpResourceAsset;
            temp.resources = [tmpResource];
        }

        if (customFields && customFields.length > 0) {
            temp.customFields = [];
            temp.customFields.push(customFields.pop());
        }

        if (destinations && destinations.length > 0) {
            temp.destinations = [];
            temp.destinations.push(destinations.pop());
        }
        if (contacts && contacts.length > 0) {
            temp.contacts = [contacts.pop()];
        }
        extraRows.push(temp);

        return this.generateExtraJobRow(job, items, labels, notes, customFields, destinations, extraRows, resources, contacts);
    },

    generateExtraReportArticleJobRows: function(parentReport, items, extraRows) {
        var temp = new Job();
        if (items.length > 0) {
            var tempReport = parentReport.clone();
            tempReport.items = [];
            tempReport.items.push(items.pop());
            temp.report = parentReport;

            extraRows.push(temp);
            return this.generateExtraReportArticleJobRows(parentReport, items, extraRows);
        } else {
            return extraRows;
        }
    },

    createRowForJob: function(job, reports) {
        var extraRows = [];
        var items = [];
        var labels = [];
        var notes = [];
        var contacts = [];
        var customFields = [];
        var destinations = [];
        var priceSum = 0;

        if (job.contacts && job.contacts.length > 0) {
            contacts = job.contacts.slice(1);
            job.contacts = job.contacts.slice(0, 1);
        }

        if (job.customFields && job.customFields.length > 1) {
            customFields = job.customFields.slice(1);
        }

        if(job.items && job.items.length > 0) {
            for (var i = 0; i < job.items.length; i++) {
                var item = job.items[i];
                console.log(item);
                var amount = item.amount || null;
                var price = item.unitPrice || item.articleUnitPrice || null;
                if (amount && price)
                    priceSum += ((amount * price) / 100);
            }
            console.log(priceSum)
        }

        if (job.items && job.items.length > 1) {
            items = job.items.slice(1);
        }

        if (job.labels && job.labels.length > 1) {
            labels = job.labels.slice(1);
        }

        if(job.events && job.events.length > 1) {
            var first = true;
            for(var i=0; i<job.events.length; i++) {
                if(job.events[i].type === "NOTE") {
                    if (!first)
                        notes.push(job.events[i]);
                    else {
                        first = false;
                    }
                }
            }
        }
        var fakeReports = [];
        if (reports && reports.length > 0) {
            for (var i = 0; i < reports.length; i++) {
                var tempItems = reports[i].items ? reports[i].items : [];
                reports[i].items = [];
                if (tempItems.length > 0) {
                    reports[i].items.push(tempItems.pop());
                    var item = reports[i].items[0];
                    var amount = item.amount || null;
                    var price = item.unitPrice || item.articleUnitPrice || null;
                    if (amount && price)
                        priceSum += ((amount * price) / 100);

                    fakeReports.push(reports[i]);
                    var userId = reports[i].userId;
                    for (var j = 0; j < tempItems.length; j++) {
                        var tempReport = new WorkReport();
                        tempReport.set('userId', userId);
                        tempReport.items = [];
                        tempReport.items.push(tempItems[j]);

                        var item = tempItems[j];
                        var amount = item.amount || null;
                        var price = item.unitPrice || item.articleUnitPrice || null;

                        if (amount && price) {
                            priceSum += ((amount * price) / 100);
                        }

                        fakeReports.push(tempReport);
                    }
                } else {
                    fakeReports.push(reports[i]);
                }

            }
            fakeReports.reverse();
            reports = fakeReports;
        }
        if (reports && job.resources) {
            var resources = JSON.parse(JSON.stringify(job.resources));
            for (var i = 0; i < resources.length; i++) {
                for (var j = 0; j < reports.length; j++) {
                    if (resources[i].userId == reports[j].userId || reports[j].get && reports[j].get('userId') == resources[i].userId) {
                        if (!resources[i].reports) resources[i].reports = [];
                        resources[i].reports.push(reports[j]);
                    }
                }
            }
            var tmpResource;
            if (resources && resources[0]) {
                tmpResource = JSON.parse(JSON.stringify(resources[0]));
                tmpResource.assets = [];
                tmpResource.assets = resources[0].assets && resources[0].assets.length > 0 ? [resources[0].assets.pop()] : [];
                tmpResource.reports = [];
                tmpResource.reports = resources[0].reports && resources[0].reports.length > 0 ? [resources[0].reports.pop()] : [];
                if (resources[0].assets.length <= 0 && (!resources[0].reports || resources[0].reports && resources[0].reports.length <= 0)) resources.shift();

            }
            job.resources = [];
            job.resources.push(tmpResource);
        }
        var fakeDestinations = [];
        destinations = job.destinations;
        if (destinations && destinations.length > 0) {
            for (var i = 0; i < destinations.length; i++) {
                var tempCustomFields = destinations[i].customFields ? destinations[i].customFields : [];
                destinations[i].customFields = [];
                if (tempCustomFields.length > 0) {
                    destinations[i].customFields.push(tempCustomFields.pop());
                    fakeDestinations.push(destinations[i]);
                    for (var j = 0; j < tempCustomFields.length; j++) {
                        var tempDestination = destinations[i] ? JSON.parse(JSON.stringify(destinations[i])) : {};//new Destination();
                        tempDestination.customFields = [];
                        tempDestination.customFields.push(tempCustomFields[j]);
                        fakeDestinations.push(tempDestination);
                    }
                } else {
                    fakeDestinations.push(destinations[i]);
                }
            }
            job.destinations = [];
            fakeDestinations.reverse();
            job.destinations.push(fakeDestinations.pop());
            destinations = fakeDestinations;
        }
        extraRows = this.generateExtraJobRow(job, items, labels, notes, customFields, destinations, [], resources, contacts);
        if (this.showPricing()) job.priceSum = priceSum;
        var rows = [];
        rows.push(this.createRowForJobOrExtra(job));
        for (var i = 0; i < extraRows.length; i++) {
            rows.push(this.createRowForJobOrExtra(extraRows[i]));
        }

        return rows;
    },

    createRowForJobOrExtra: function(job){
        var headerRow = [];
        var dataRow = [];

        /*headerRow.push("Internt Id");
        dataRow.push(job.id);*/

        headerRow.push(i18next.t('jobExcelExportMapping_jobNo'));
        if (job.groupPrefix && job.jobNo) {
            dataRow.push('#' + job.groupPrefix + job.jobNo);
        }
        else {
            dataRow.push(job.jobNo ? job.jobNo : '');
        }

        headerRow.push(i18next.t('jobExcelExportMapping_jobCreateTime'));
        dataRow.push(job.creationTimeStamp ? Formatting.date(job.creationTimeStamp,null, true) : '');

        headerRow.push(i18next.t('jobExcelExportMapping_jobTitle'));
        dataRow.push(job.title ? '\''+job.title : '');

        headerRow.push(i18next.t('jobExcelExportMapping_jobStartDate'));
        dataRow.push(job.startTime ? Formatting.datePart(job.startTime,true) : '');
        headerRow.push(i18next.t('jobExcelExportMapping_jobStartTime'));
        dataRow.push(job.startTime ? Formatting.time(job.startTime) : '');
        headerRow.push(i18next.t('jobExcelExportMapping_jobEndDate'));
        dataRow.push(job.endTime ? Formatting.datePart(job.endTime, true) : '');
        headerRow.push(i18next.t('jobExcelExportMapping_jobEndTime'));
        dataRow.push(job.endTime ? Formatting.time(job.endTime) : '');

        headerRow.push(i18next.t('jobExcelExportMapping_jobLabel')+'|text');
        if (job.labels && job.labels.length > 0) {
            dataRow.push(job.labels[0])
        } else {
            dataRow.push("")
        }

        headerRow.push(i18next.t('jobExcelExportMapping_activity'));
        dataRow.push(job.activityName ? job.activityName : '');

        headerRow.push(i18next.t('jobExcelExportMapping_customerNo'));
        dataRow.push(job.customerNo ? job.customerNo : job.customerNoText || '');
        headerRow.push(i18next.t('jobExcelExportMapping_customerName'));
        dataRow.push(job.customerName ? job.customerName : '');

        headerRow.push(i18next.t('jobExcelExportMapping_customerProjectName'));
        dataRow.push(job.customerProjectName ? job.customerProjectName : '');
        headerRow.push(i18next.t('jobExcelExportMapping_customerProjectNo'));
        dataRow.push(job.customerProjectNo ? job.customerProjectNo : job.customerProjectNoText || '');

        headerRow.push(i18next.t('jobExcelExportMapping_referenceNo'));
        dataRow.push(job.referenceNo ? job.referenceNo+'|forcetext' : '');

        headerRow.push(i18next.t('jobExcelExportMapping_contactName'));
        headerRow.push(i18next.t('jobExcelExportMapping_contactEmail'));
        headerRow.push(i18next.t('jobExcelExportMapping_contactPhone'));
        var contact = (job.contacts && job.contacts.length > 0) ? job.contacts[0] : {};
        dataRow.push(contact.name || '');
        dataRow.push(contact.emailAddress || '');
        dataRow.push(contact.phoneNo || '');

        var destination = job.destinations && job.destinations.length > 0 ? job.destinations[0] : null;
        headerRow.push(i18next.t('jobExcelExportMapping_locationAddress'));
        dataRow.push(destination && destination.location && destination.location.placeName ? destination.location.placeName : '');
        headerRow.push(i18next.t('jobExcelExportMapping_locationDescription'));
        dataRow.push(destination && destination.locationDescription ? destination.locationDescription : '');

        headerRow.push(i18next.t('jobExcelExportMapping_customFieldDestinationLabel'));
        dataRow.push(destination && destination.customFields && destination.customFields.length > 0 && destination.customFields[0] ? destination.customFields[0].label : "");
        headerRow.push(i18next.t('jobExcelExportMapping_customFieldDestinationValue'));
        dataRow.push(destination && destination.customFields && destination.customFields.length > 0 && destination.customFields[0] ? this.parseCustomFieldValue(destination.customFields[0].value, destination.customFields[0].type) : "");
        /*if (destination != null && destination.customFields && destination.customFields.length > 0) {
            for (var i = 0; i < destination.customFields.length; i++) {
                headerRow.push(destination.customFields[i].label);
                dataRow.push(destination.customFields[i].value);
            }
        }*/

        headerRow.push(i18next.t('jobExcelExportMapping_jobDescription'));
        dataRow.push(job.description ? job.description : '');

        headerRow.push(i18next.t('jobExcelExportMapping_jobState'));
        dataRow.push(job.state ? job.state : '');

        // items
        if (job.items && job.items.length > 0) {
            var item = job.items[0];
            headerRow.push(i18next.t('jobExcelExportMapping_articleNo'));
            dataRow.push(item.articleNo ? item.articleNo : "");

            headerRow.push(i18next.t('jobExcelExportMapping_articleDescription'));
            dataRow.push(item.description ?  item.description : "");

            headerRow.push(i18next.t('jobExcelExportMapping_articleAmount'));
            dataRow.push(item.amount ? item.amount : "");
            headerRow.push(i18next.t('jobExcelExportMapping_articleUnit'));
            dataRow.push(item.unit ? item.unit : "");

            if (this.showPricing()) {
                headerRow.push(i18next.t('jobExcelExportMapping_articlePrice'));
                var price = item.unitPrice || item.articleUnitPrice || null;
                if (price && item.amount) {
                    dataRow.push(price * item.amount / 100);
                } else
                    dataRow.push("");
            }
        } else {
            headerRow.push(i18next.t('jobExcelExportMapping_articleNo'));
            dataRow.push("");
            headerRow.push(i18next.t('jobExcelExportMapping_articleDescription'));
            dataRow.push("");
            headerRow.push(i18next.t('jobExcelExportMapping_articleAmount'));
            dataRow.push("");
            headerRow.push(i18next.t('jobExcelExportMapping_articleUnit'));
            dataRow.push("");
            if (this.showPricing()) {
                headerRow.push(i18next.t('jobExcelExportMapping_articlePrice'));
                dataRow.push("");
            }
        }

        headerRow.push(i18next.t('jobExcelExportMapping_notes'));
        //var hasNote = false;
        var notes = '';
        if (job.events && job.events.length > 0) {
            for(var i = 0; i < job.events.length; i++) {
                if(job.events[i].type === "NOTE") {
                    notes += job.events[i].comment ? job.events[i].comment + '\n': '';
                    //dataRow.push(job.events[i].comment ? job.events[i].comment : '');
                    //hasNote = true;
                    break;
                }
            }
        }
        dataRow.push(notes);
        //if(!hasNote) { dataRow.push("");}
        headerRow.push(i18next.t('jobExcelExportMapping_customFieldLabel'));
        dataRow.push(job.customFields && job.customFields[0] && job.customFields[0].label ? job.customFields[0].label : "");

        headerRow.push(i18next.t('jobExcelExportMapping_customFieldValue'));
        dataRow.push(job.customFields && job.customFields[0] && job.customFields[0].value ? this.parseCustomFieldValue(job.customFields[0].value, job.customFields[0].type) : "");

        headerRow.push(i18next.t('jobExcelExportMapping_resource'));
        var resource = job.resources && job.resources.length > 0 ? job.resources[0] : null;
        var report = resource && resource.reports && resource.reports.length > 0 ? resource.reports[0] : null;
        var resourceAsset = resource && resource.assets && resource.assets.length > 0 ? resource.assets[0] : null;

        dataRow.push(resource != null && resource.fullName ? resource.fullName : "");
        headerRow.push(i18next.t('jobExvelExportMapping_resourceAssetNo'));
        dataRow.push(resourceAsset && resourceAsset.assetNo ? resourceAsset.assetNo : '');

        headerRow.push(i18next.t('jobExvelExportMapping_resourceAsset'));
        dataRow.push(resourceAsset && resourceAsset.assetName ? resourceAsset.assetName : '');

        headerRow.push(i18next.t('jobExvelExportMapping_resourceAssetType'));
        dataRow.push(resourceAsset ? (resourceAsset.assetTypeName ? resourceAsset.assetTypeName : '') : '');

        headerRow.push(i18next.t('jobExcelExportMapping_reportDescription'));
        dataRow.push(report && report.description ? report.description : "");

        //var reportData = "";
        headerRow.push(i18next.t('jobExcelExportMapping_reportDate'));
        dataRow.push(report && report.startTime ? Formatting.datePart(report.startTime, true): '');

        headerRow.push(i18next.t('jobExcelExportMapping_reportStart'));
        dataRow.push(report && report.startTime ? Formatting.time(report.startTime): '');
        //if(job.report && job.report.starTime) {
            //reportData += "Start " + Formatting.datePart(job.report.startTime, true) + " ";
        //}

        headerRow.push(i18next.t('jobExcelExportMapping_reportEnd'));
        dataRow.push(report && report.endTime ? Formatting.time(report.endTime): '');

        headerRow.push(i18next.t('jobExcelExportMapping_reportPause'));
        dataRow.push(report && report.pauseDuration ? Formatting.duration(report.pauseDuration): '');
        //if(job.report && job.report.endTime) {
        //    reportData += "Slut " + Formatting.datePart(job.report.endTime, true) + " ";
        //}

        headerRow.push(i18next.t('jobExcelExportMapping_reportArticle'));
        dataRow.push(report && report.items && report.items.length > 0 && report.items[0] ? report.items[0].description : '');

        headerRow.push(i18next.t('jobExcelExportMapping_reportAmount'));
        dataRow.push(report && report.items && report.items.length > 0 && report.items[0] ? report.items[0].amount : '');

        headerRow.push(i18next.t('jobExcelExportMapping_reportUnit'));
        dataRow.push(i18next.t(report && report.items && report.items.length > 0 && report.items[0] ? 'reportUnitShort_'+report.items[0].unit : ''));

        /*if (job.report && job.report.items && job.report.items.length > 0) {
            if (job.report.items[0].description)
                reportData += job.report.items[0].description + " ";
            if (job.report.items[0].amount) {
                reportData += job.report.items[0].amount + " ";
        if (job.report.items[0].unit) {
                    switch (job.report.items[0].unit) {
                        case "HOURS":
                            reportData += "h";
                            break;
                        case "KM":
                            reportData += "Km";
                            break;
                        case "ITEMS":
                            reportData += "St";
                            break;
                        case "MONEY":
                            reportData += "St";
                            break;
                        case "DAY":
                            reportData += "Dag";
                            break;
                        case "MONTH":
                            reportData += "Månad";
                            break;
                        case "KG":
                            reportData += "kg";
                            break;
                        case "GRAM":
                            reportData += "g";
                            break;
                        case "TON":
                            reportData += "Ton";
                            break;
                        case "METER":
                            reportData += "m";
                            break;
                        case "MM" :
                            reportData += "mm";
                            break;
                        case "M2":
                            reportData += "kvm";
                            break;
                        case"M3":
                            reportData += "Kubikmeter";
                            break;
                        case "LITRE":
                            reportData += "Liter";
                            break;
                        default:
                            break;
                    }
                }
            }
        }

        dataRow.push(reportData);
        //*/

        if (this.showPricing()) {
            headerRow.push(i18next.t('jobExcelExportMapping_reportPrice'));

            if(report && report.items && report.items.length > 0 && report.items[0].amount && report.items[0].amount > 0 && (report.items[0].unitPrice || report.items[0].articleUnitPrice)) {
                var price = report.items[0].unitPrice || report.items[0].articleUnitPrice || null;
                dataRow.push(price * report.items[0].amount / 100);
            } else {
                dataRow.push("");
            }

            headerRow.push(i18next.t('jobExcelExportMapping_jobPriceSum'));
            dataRow.push(job.priceSum ? job.priceSum : "");
        }

        /*headerRow.push(CoreMsg.jobExcelExportMapping.articleAmount);
        dataRow.push(article.amount ? article.amount : "");

        headerRow.push(CoreMsg.jobExcelExportMapping.articleInvoiced);
        dataRow.push(article.invoicedAmount ? article.invoicedAmount : "");

        headerRow.push(CoreMsg.jobExcelExportMapping.articleUnit);
        dataRow.push(article.unit ? article.unit : "");

        headerRow.push(CoreMsg.jobExcelExportMapping.articleUnitPrice);
        dataRow.push(article.unitPrice ? article.unitPrice : "");*/

        /*
        // Custom Fields
        if (job.customFields.length > 0) {
            for(var i = 0; i < job.customFields.length; i++) {
                headerRow.push(job.customFields[i].label);
                dataRow.push(job.customFields[i].value);
            }
        }*/

        return [headerRow, dataRow];
    },

    parseCustomFieldValue: function(value, type) {
        if (type === "DATE") {
            console.log("DATEOSVVVVVVVV", Formatting.datePart(value, true));
            return Formatting.datePart(parseInt(value), true)
        } else if (type === "TIME") {
            return Formatting.time(parseInt(value))
        } else if (type === "DATETIME") {
            return Formatting.date(parseInt(value), true)
        } else {
            return value;
        }
    },

    createRowForSkanskaSpecial: function(job){
        var headerRow = [];
        var dataRow = [];

        var destinations = job.destinations;
        var fromAddress = destinations && destinations.length > 0 ? destinations[0] : null;
        var toAddress = destinations && destinations.length > 1 ? destinations[1] : null;

        var customFields = _(job.customFields);
        headerRow.push('Lastplats');
        dataRow.push(fromAddress ? fromAddress.locationDescription : '');
        headerRow.push('Adress');
        dataRow.push(fromAddress && fromAddress.location && fromAddress.location.placeName ? fromAddress.location.placeName : '');
        headerRow.push('Gata');
        dataRow.push(this.addressToStreetPart(fromAddress));
        headerRow.push('Postnr');
        dataRow.push(this.addressToPostalCode(fromAddress));
        headerRow.push('Ort');
        dataRow.push(this.addressToArea(fromAddress));
        headerRow.push('Produkt');
        dataRow.push(customFields && customFields.findWhere({name: "material"}) ? customFields.findWhere({name: "material"}).value : '');
        headerRow.push('Information');
        dataRow.push(job.description);
        headerRow.push('Längd m');
        dataRow.push(customFields && customFields.findWhere({name: "lngdm"}) ? customFields.findWhere({name: "lngdm"}).value : '');
        headerRow.push('Vikt kg/m');
        dataRow.push(customFields && customFields.findWhere({name: "viktkgm"}) ? customFields.findWhere({name: "viktkgm"}).value : '');
        headerRow.push('Totalvikt');
        dataRow.push(customFields && customFields.findWhere({name: "totalvikt"}) ? customFields.findWhere({name: "totalvikt"}).value : '');
        headerRow.push('Arbetsplats');
        dataRow.push(toAddress ? toAddress.locationDescription : '');
        headerRow.push('Adress');
        dataRow.push(toAddress && toAddress.location && toAddress.location.placeName ? toAddress.location.placeName : '');
        headerRow.push('Gata');
        dataRow.push(this.addressToStreetPart(toAddress));
        headerRow.push('Postnr');
        dataRow.push(this.addressToPostalCode(toAddress));
        headerRow.push('Ort');
        dataRow.push(this.addressToArea(toAddress));
        headerRow.push('Referens');
        dataRow.push(job.contact ? job.contact.name : '');
        headerRow.push('Telefon|text');
        dataRow.push(job.contact ? job.contact.phoneNo : '');
        headerRow.push('Ert ordernr');
        dataRow.push(job.referenceNo);
        headerRow.push('Prel.Tid|text');
        dataRow.push(new Date(job.startTime).toString('HHmm')); // this.startTimePart());
        headerRow.push('Lev.datum');
        dataRow.push(new Date(job.startTime).toString('yyyyMMdd')); //this.startDatePart());
        //headerRow.push('Lassnr');
        //dataRow.push(customFields && customFields.findWhere({name: "lassnr"}) ? customFields.findWhere({name: "lassnr"}).value : '');
        headerRow.push('Kundnr');
        dataRow.push(job.customerNo ? job.customerNo:'');
        headerRow.push('Projektnr|text');
        dataRow.push(job.customerProjectNoText ? job.customerProjectNoText:'');
        headerRow.push('Kranbil');
        dataRow.push(customFields && customFields.findWhere({name: "kran"}) && customFields.findWhere({name: 'kran'}).value == 'true' ? true : false);
        headerRow.push('Retur');
        dataRow.push(customFields && customFields.findWhere({name: "retur"}) && customFields.findWhere({name: 'retur'}).value == 'true' ? true : false);
        headerRow.push('Sträcka (km)');
        dataRow.push(job.totalDistance ? job.totalDistance / 1000 : '');

        return [headerRow, dataRow];

    },
    createRowForSkanskaSydvastSpecial: function(job){
        var headerRow = [];
        var dataRow = [];

        var destinations = job.destinations;
        var fromAddress = destinations && destinations.length > 0 ? destinations[0] : null;
        var toAddress = destinations && destinations.length > 1 ? destinations[1] : null;

        var customFields = _(job.customFields);
        headerRow.push('Lastplats');
        dataRow.push(fromAddress ? fromAddress.locationDescription : '');
        headerRow.push('Adress');
        dataRow.push(fromAddress && fromAddress.location && fromAddress.location.placeName ? fromAddress.location.placeName : '');
        headerRow.push('Gata');
        dataRow.push(this.addressToStreetPart(fromAddress));
        headerRow.push('Postnr');
        dataRow.push(this.addressToPostalCode(fromAddress));
        headerRow.push('Ort');
        dataRow.push(this.addressToArea(fromAddress));
        headerRow.push('Information');
        dataRow.push(job.description);

        headerRow.push('Massaresurs');
        dataRow.push(customFields && customFields.findWhere({name: "massaresurs"}) ? customFields.findWhere({name: "massaresurs"}).value : '');
        headerRow.push('Transportresurs');
        dataRow.push(customFields && customFields.findWhere({name: "resurs"}) ? customFields.findWhere({name: "resurs"}).value : '');
        headerRow.push('Lastningsintervall');
        dataRow.push(customFields && customFields.findWhere({name: "lastningsintervall"}) ? customFields.findWhere({name: "lastningsintervall"}).value : '');
        headerRow.push('Fordonstyp');
        dataRow.push(customFields && customFields.findWhere({name: "6axltrailer29ton"}) ? customFields.findWhere({name: "6axltrailer29ton"}).value : '');
        headerRow.push('Antal');
        dataRow.push(customFields && customFields.findWhere({name: "antalsektionerattanvnda"}) ? customFields.findWhere({name: "antalsektionerattanvnda"}).value : '');
        headerRow.push('Övrigt');
        dataRow.push(customFields && customFields.findWhere({name: "egnafordon"}) ? customFields.findWhere({name: "egnafordon"}).value : '');
        headerRow.push('Skyltning Trafikverket');
        dataRow.push(customFields && customFields.findWhere({name: "skyltningtrafikverket"}) && customFields.findWhere({name: 'skyltningtrafikverket'}).value == 'true' ? true : false);

        headerRow.push('Arbetsplats');
        dataRow.push(toAddress ? toAddress.locationDescription : '');
        headerRow.push('Adress');
        dataRow.push(toAddress && toAddress.location && toAddress.location.placeName ? toAddress.location.placeName : '');
        headerRow.push('Gata');
        dataRow.push(this.addressToStreetPart(toAddress));
        headerRow.push('Postnr');
        dataRow.push(this.addressToPostalCode(toAddress));
        headerRow.push('Ort');
        dataRow.push(this.addressToArea(toAddress));

        headerRow.push('Referens');
        dataRow.push(job.contact ? job.contact.name : '');
        headerRow.push('Telefon|text');
        dataRow.push(job.contact ? job.contact.phoneNo : '');
        headerRow.push('Ert ordernr');
        dataRow.push(job.referenceNo);
        headerRow.push('Prel.Tid|text');
        dataRow.push(new Date(job.startTime).toString('HHmm'));
        headerRow.push('Lev.datum');
        dataRow.push(new Date(job.startTime).toString('yyyyMMdd'));
        headerRow.push('Kundnr');
        dataRow.push(job.customerNo ? job.customerNo:'');
        headerRow.push('Projektnr|text');
        dataRow.push(job.customerProjectNoText ? job.customerProjectNoText:'');
        headerRow.push('Sträcka (km)');
        dataRow.push(job.totalDistance ? job.totalDistance / 1000 : '');

        return [headerRow, dataRow];
    },

    createRowForSkanskaAsfalt: function(job){
        var headerRow = [];
        var dataRow = [];

        var destinations = job.destinations;
        var fromAddress = destinations && destinations.length > 0 ? destinations[0] : null;
        var toAddress = destinations && destinations.length > 1 ? destinations[1] : null;

        var customFields = _(job.customFields);
        headerRow.push('title');
        dataRow.push(job.title);
        headerRow.push('Lastplats');
        dataRow.push(fromAddress ? fromAddress.locationDescription : '');
        headerRow.push('Adress');
        dataRow.push(fromAddress && fromAddress.location && fromAddress.location.placeName ? fromAddress.location.placeName : '');
        headerRow.push('Gata');
        dataRow.push(this.addressToStreetPart(fromAddress));
        headerRow.push('Postnr');
        dataRow.push(this.addressToPostalCode(fromAddress));
        headerRow.push('Ort');
        dataRow.push(this.addressToArea(fromAddress));
        headerRow.push('Information');
        dataRow.push(job.description);

        //headerRow.push('Massaresurs');
        //dataRow.push(customFields && customFields.findWhere({name: "massaresurs"}) ? customFields.findWhere({name: "massaresurs"}).value : '');
        //headerRow.push('Transportresurs');
        //dataRow.push(customFields && customFields.findWhere({name: "resurs"}) ? customFields.findWhere({name: "resurs"}).value : '');
        //headerRow.push('Lastningsintervall');
        //dataRow.push(customFields && customFields.findWhere({name: "lastningsintervall"}) ? customFields.findWhere({name: "lastningsintervall"}).value : '');
        headerRow.push('Fordonstyp');
        dataRow.push(customFields && customFields.findWhere({name: "fordonstyp"}) ? customFields.findWhere({name: "fordonstyp"}).value : '');
        headerRow.push('Material: mängd');
        dataRow.push(customFields && customFields.findWhere({name: "materialmngd"}) ? customFields.findWhere({name: "materialmngd"}).value : '');
        headerRow.push('Bil');
        dataRow.push(job.resources && job.resources[0] ? job.resources[0].fullName : "");
        headerRow.push('Övrigt');
        dataRow.push(customFields && customFields.findWhere({name: "vrigt"}) ? customFields.findWhere({name: "vrigt"}).value : '');
        //headerRow.push('Antal');
        //dataRow.push(customFields && customFields.findWhere({name: "antalsektionerattanvnda"}) ? customFields.findWhere({name: "antalsektionerattanvnda"}).value : '');
        //headerRow.push('Övrigt');
        //dataRow.push(customFields && customFields.findWhere({name: "egnafordon"}) ? customFields.findWhere({name: "egnafordon"}).value : '');
        //headerRow.push('Skyltning Trafikverket');
        //dataRow.push(customFields && customFields.findWhere({name: "skyltningtrafikverket"}) && customFields.findWhere({name: 'skyltningtrafikverket'}).value == 'true' ? true : false);

        headerRow.push('Arbetsplats');
        dataRow.push(toAddress ? toAddress.locationDescription : '');
        headerRow.push('Adress');
        dataRow.push(toAddress && toAddress.location && toAddress.location.placeName ? toAddress.location.placeName : '');
        headerRow.push('Gata');
        dataRow.push(this.addressToStreetPart(toAddress));
        headerRow.push('Postnr');
        dataRow.push(this.addressToPostalCode(toAddress));
        headerRow.push('Ort');
        dataRow.push(this.addressToArea(toAddress));

        headerRow.push('Referens');
        dataRow.push(job.contact ? job.contact.name : '');
        headerRow.push('Telefon|text');
        dataRow.push(job.contact ? job.contact.phoneNo : '');
        headerRow.push('Ert ordernr');
        dataRow.push(job.referenceNo);
        headerRow.push('Prel.Tid|text');
        dataRow.push(new Date(job.startTime).toString('HHmm'));
        headerRow.push('Lev.datum');
        dataRow.push(new Date(job.startTime).toString('yyyyMMdd'));
        headerRow.push('Kundnr');
        dataRow.push(job.customerNo ? job.customerNo:'');
        headerRow.push('Projektnr|text');
        dataRow.push(job.customerProjectNoText ? job.customerProjectNoText:'');
        headerRow.push('Sträcka (km)');
        dataRow.push(job.totalDistance ? job.totalDistance / 1000 : '');

        return [headerRow, dataRow];
    },

    createRowForFormtrappan: function(job){
        var headerRow = [];
        var dataRow = [];

        var destinations = job.destinations;
        var address = destinations && destinations.length > 0 ? destinations[0] : null;

        var customFields = _(job.customFields);
        headerRow.push('Titel');
        dataRow.push(job.title);
        headerRow.push('Uppdragsnr');
        dataRow.push(job.jobNo);
        headerRow.push('Datum');
        dataRow.push(job.startTime != null ? new Date(job.startTime).toString('yyyy-MM-dd') : '');
        headerRow.push('Tid');
        dataRow.push(job.startTime != null ? new Date(job.startTime).toString('HH:mm') : '');

        headerRow.push('Namn');
        dataRow.push(job.contact ? job.contact.name : '');
        headerRow.push('Email|text');
        dataRow.push(job.contact ? job.contact.emailAddress : '');
        headerRow.push('Telefon|text');
        dataRow.push(job.contact ? job.contact.phoneNo : '');

        headerRow.push('Gata');
        dataRow.push(this.addressToStreetPart(address));
        headerRow.push('PostNr');
        dataRow.push(this.addressToPostalCode(address));
        headerRow.push('Ort');
        dataRow.push(this.addressToArea(address));

        headerRow.push('Information');
        dataRow.push(job.description);
        headerRow.push('Adress(full)');
        dataRow.push(address && address.location && address.location.placeName ? address.location.placeName : '');

        return [headerRow, dataRow];
    },

    showPricing: function() {
        if (!Core.client.me || !Core.client.me.get('groupMemberships'))
            return false;

        var activeGroupIds = [];
        Core.client.me.get('groupMemberships').forEach(function(group) {
            if (group.active) activeGroupIds.push(group.groupId);
        });

        return Core.client.hasPermissionInAnyOfGroups('view_pricing', activeGroupIds)
                || Core.client.hasPermission('view_all_data')
                || Core.client.hasPermission('edit_all_data')
    }

};
